module.exports = __webpack_public_path__ + "static/Brithday-5e79c9452cd35ee46bd9c357ac883ca8.png";